<ng-template #template>
  <ng-container *ngIf="isDisplayed">
    <div class="l-mybooking__option-item">
      <asw-next-action-item
        (clickNextAction)="onClick()"
        [canBeClicked]="canBeClicked && canBeClickedNext"
        [title]="guideLabel | staticMsg"
        [titleAria]="guideLabelReader | staticMsg"
        itemId="ticketing"
      >
        <ng-container *ngIf="displayApprovableOnAnaBiz">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="approvableOnAnaBizLabel | staticMsg"
          ></asw-next-action-item-content>
        </ng-container>

        <!-- [1.2.47] 空席待ちステータスの旨 -->
        <ng-container *ngIf="displayWaitListStatus">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="'label.statusTitle' | staticMsg"
            [content]="'label.seatWaiting' | staticMsg"
          ></asw-next-action-item-content>
        </ng-container>
        <!-- /[1.2.47] 空席待ちステータスの旨 -->

        <!-- 支払総額 -->
        <ng-container *ngIf="displayTotalAmount">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="'label.paymentTotalAmount2' | staticMsg"
            [content]="totalAmount"
            [contentClass]="displayHighlightedTotalAmount"
          ></asw-next-action-item-content>
        </ng-container>

        <!-- マイル -->
        <ng-container *ngIf="displayMiles">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="'label.requiredMileage1' | staticMsg"
            [content]="miles"
          ></asw-next-action-item-content>
        </ng-container>

        <!-- 税金 -->
        <ng-container *ngIf="displayTax">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="'label.taxFare' | staticMsg"
            [content]="tax"
          ></asw-next-action-item-content>
        </ng-container>

        <!-- 発券期限 -->
        <ng-container *ngIf="displayTicketingDeadline">
          <asw-next-action-item-content
            *aswNextActionItemContent
            [title]="expirationLabel | staticMsg"
            [content]="ticketingDeadline"
          ></asw-next-action-item-content>
        </ng-container>

        <!-- 発券期限が迫っている旨 -->
        <ng-container *ngIf="displayTicketDeadlineWarning">
          <asw-next-action-item-content-attention
            *aswNextActionItemContentAttention
            [canBeClicked]="canBeClicked"
            [attentionMessage]="ticketDeadlineWarning | staticMsg"
          ></asw-next-action-item-content-attention>
        </ng-container>
      </asw-next-action-item>
    </div>
  </ng-container>
</ng-template>
